import React, { Component } from 'react';
/**
 * List
 */
export class List extends Component { // eslint-disable-line react/prefer-stateless-function
  state = {
    dataLoaded: false
  }
  componentDidMount(){
    this.props.fetchList('corporate').then(() => {
      this.setState({
        ...this.state,
        dataLoaded: true
      })
    });
  }
  render() {
    const { corporateExercises } = this.props;
    if (this.state.dataLoaded) {
      return (
        <div>
          <h1>Corporate Exercises</h1>
          <ol>
            {
              Object.values(corporateExercises).map((exercise,i) => (
                <li key={i}>
                  {exercise.name}
                  <video controls src={exercise.videoUrl}
                    style={{width:'100%'}} autoPlay loop />
                </li>
              ))
            }
          </ol>

        </div>

      );
    }
    return null;
  }
}

export default List;



// WEBPACK FOOTER //
// ./src/components/exercises/CorporateList.js